module.exports = __webpack_public_path__ + "static/img/cty_cover.bd4702f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/cty_cover.jpg
// module id = u283
// module chunks = 0